import { defineMessages } from 'react-intl';

export default defineMessages({

  itineraryChange: {
    id: 'fastCover.itineraryChange.itineraryChange',
    defaultMessage: 'Are you claiming for Itinerary Change?',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.itineraryChange.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  travelInterruption: {
    id: 'fastCover.itineraryChange.travelInterruption',
    defaultMessage: 'Are you claiming for Trip Interruption?',
  },

  travelDelay: {
    id: 'fastCover.itineraryChange.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.itineraryChange.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.itineraryChange.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.itineraryChange.reasons2',
    defaultMessage: 'Your Unforeseen Sickness or Injury or, the Sickness or Injury of a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.itineraryChange.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity',
  },

  reasons4: {
    id: 'fastCover.itineraryChange.reasons4',
    defaultMessage: 'A Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplier: {
    id: 'fastCover.itineraryChange.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  companyNameTravelInterruption: {
    id: 'fastCover.itineraryChange.companyNameTravelInterruption',
    defaultMessage: 'Company Name',
  },

  addressTravelInterruption: {
    id: 'fastCover.itineraryChange.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.itineraryChange.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.itineraryChange.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.itineraryChange.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.itineraryChange.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumber: {
    id: 'fastCover.itineraryChange.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  includedInPackage: {
    id: 'fastCover.itineraryChange.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  lossInformation: {
    id: 'fastCover.itineraryChange.lossInformation',
    defaultMessage: 'Loss Information',
  },

  addLossInformation: {
    id: 'fastCover.itineraryChange.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.itineraryChange.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.itineraryChange.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.itineraryChange.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.itineraryChange.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.itineraryChange.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.itineraryChange.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.itineraryChange.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.itineraryChange.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.itineraryChange.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.itineraryChange.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.itineraryChange.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruise/travel agent/etc.)',
  },

  amountPaidLoss: {
    id: 'fastCover.itineraryChange.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.itineraryChange.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.itineraryChange.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  fromWhom: {
    id: 'fastCover.itineraryChange.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  reasonsForDelay: {
    id: 'fastCover.itineraryChange.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.itineraryChange.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.itineraryChange.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident enroute to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.itineraryChange.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.itineraryChange.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.itineraryChange.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.itineraryChange.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.itineraryChange.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.itineraryChange.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.itineraryChange.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.itineraryChange.delayInformation',
    defaultMessage: 'Item Information',
  },

  addDelayInformation: {
    id: 'fastCover.itineraryChange.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.itineraryChange.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.itineraryChange.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  yes: {
    id: 'fastCover.itineraryChange.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.itineraryChange.no',
    defaultMessage: 'No',
  },
  fromDate: {
    id: 'fastCover.itineraryChange.fromDate',
    defaultMessage: 'From Date',
  },
  toDate: {
    id: 'fastCover.itineraryChange.toDate',
    defaultMessage: 'To Date',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.itineraryChange.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.itineraryChange.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.itineraryChange.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.itineraryChange.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.itineraryChange.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.itineraryChange.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.itineraryChange.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.itineraryChange.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.itineraryChange.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.itineraryChange.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.itineraryChange.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.itineraryChange.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.itineraryChange.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.itineraryChange.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.itineraryChange.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.itineraryChange.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.itineraryChange.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.itineraryChange.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.itineraryChange.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.itineraryChange.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.itineraryChange.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.itineraryChange.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.itineraryChange.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.itineraryChange.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.itineraryChange.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.itineraryChange.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.itineraryChange.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.itineraryChange.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.itineraryChange.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.itineraryChange.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.itineraryChange.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.itineraryChange.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.itineraryChange.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.itineraryChange.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.itineraryChange.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.itineraryChange.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.itineraryChange.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.itineraryChange.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.itineraryChange.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.itineraryChange.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.itineraryChange.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.itineraryChange.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.itineraryChange.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.itineraryChange.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.itineraryChange.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.itineraryChange.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.itineraryChange.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.itineraryChange.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.itineraryChange.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.itineraryChange.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.itineraryChange.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.itineraryChange.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.itineraryChange.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.itineraryChange.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.itineraryChange.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.itineraryChange.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.itineraryChange.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  areYouCancellingTheTripDueToMedicalReasons: {
    id: 'fastCover.medicalExpenseStep.areYouCancellingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you cancelling the trip due to medical reasons?',
  },
  dateTripWasCancelledWithTravelSupplier: {
    id: 'fastCover.itineraryChange.dateTripWasCancelledWithTravelSupplier',
    defaultMessage: 'Date Trip was cancelled with Travel Supplier',
  },
  reasonForCancellation: {
    id: 'fastCover.itineraryChange.reasonForCancellation',
    defaultMessage: 'Reason For Cancellation',
  },
  areYouInterruptingTheTripDueToMedicalReasons: {
    id: 'fastCover.itineraryChange.areYouInterruptingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you interrupting the trip due to medical reasons?',
  },
  schoolName: {
    id: 'fastCover.itineraryChange.schoolName',
    defaultMessage: 'School Name',
  },
  dateTripWasDelayedWithTravelSupplier: {
    id: 'fastCover.itineraryChange.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Date Trip was delayed with Travel Supplier',
  },
  detailsRegardingYourTripDelay: {
    id: 'fastCover.itineraryChange.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Details regarding your Trip Delay',
  },
  dateOfInitialPaymentDeposit: {
    id: 'fastCover.itineraryChange.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },
  itineraryChangeDetails: {
    id: 'fastCover.itineraryChange.itineraryChangeDetails',
    defaultMessage: 'Itinerary Change Details',
  },
  dateYouWereNotifiedOfChangeByCruiseLine: {
    id: 'fastCover.itineraryChange.dateYouWereNotifiedOfChangeByCruiseLine',
    defaultMessage: 'Date you or Travel Supplier changed the trip dates',
  },
  datesChangedByCruiseLine: {
    id: 'fastCover.itineraryChange.datesChangedByCruiseLine',
    defaultMessage: 'Original travel date(s)',
  },
  dateDelayEnded: {
    id: 'fastCover.itineraryChange.dateDelayEnded',
    defaultMessage: 'Changed travel date(s)',
  },
  descriptionOfReasonForChangeInItinerary: {
    id: 'fastCover.itineraryChange.descriptionOfReasonForChangeInItinerary',
    defaultMessage: 'Description of reason for change in itinerary',
  },
  otherInsuranceAuthorization: {
    id: 'fastCover.itineraryChange.otherInsuranceAuthorization',
    defaultMessage: 'OTHER INSURANCE / Authorisation:',
  },
  companyName: {
    id: 'fastCover.itineraryChange.companyName',
    defaultMessage: 'Company Name',
  },
  typeOfPolicy: {
    id: 'fastCover.itineraryChange.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },
  policyNumber: {
    id: 'fastCover.itineraryChange.policyNumber',
    defaultMessage: 'Policy Number',
  },
  address: {
    id: 'fastCover.itineraryChange.address',
    defaultMessage: 'Address',
  },
  cityOrTown: {
    id: 'fastCover.itineraryChange.cityOrTown',
    defaultMessage: 'City or Town',
  },
  country: {
    id: 'fastCover.itineraryChange.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.itineraryChange.postalCode',
    defaultMessage: 'Postal Code',
  },

  phone: {
    id: 'fastCover.itineraryChange.phone',
    defaultMessage: 'Phone',
  },
  contact: {
    id: 'fastCover.itineraryChange.contact',
    defaultMessage: 'Contact',
  },
  dateIncurred: {
    id: 'fastCover.itineraryChange.dateIncurred',
    defaultMessage: 'Date Incurred',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.ItineraryChange/messages.js